const topMain = () => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    let sW = window.innerWidth;
    let sH = window.innerHeight;

    let secMain = document.getElementById('jsSecMain');
    let mainWrap = secMain.querySelector('.js-main-wrap');

    let copyBox = mainWrap.querySelector('.js-copy-box');

    let copy1 = copyBox.querySelector('.js-copy-1');
    let copy2 = copyBox.querySelector('.js-copy-2');
    let copy3 = copyBox.querySelector('.js-copy-3');
    let copy4 = copyBox.querySelector('.js-copy-4');

    let copy1Paths = copy1.querySelectorAll('path');
    let copy2Paths = copy2.querySelectorAll('path');
    let copy3Paths = copy3.querySelectorAll('path');
    let copy4Paths = copy4.querySelectorAll('path');

    let imgBox1 = mainWrap.querySelector('.js-img-box-1');
    let imgBox2 = mainWrap.querySelector('.js-img-box-2');
    let imgBox3 = mainWrap.querySelector('.js-img-box-3');
    let imgBox4 = mainWrap.querySelector('.js-img-box-4');

    let subBox = mainWrap.querySelector('.js-sub-box');


    // コピーセット
    gsap.set(copy1Paths, {
      opacity: 0,
      filter: "blur(10px)",
    })
    gsap.set(copy2Paths, {
      opacity: 0,
      filter: "blur(10px)",
    })
    gsap.set(copy3Paths, {
      opacity: 0,
      filter: "blur(10px)",
    })
    gsap.set(copy4Paths, {
      opacity: 0,
      filter: "blur(10px)",
    })

    // イメージセット
    gsap.set(imgBox1, {
      clipPath: 'polygon(0 0, 0% 0, 0% 100%, 0% 100%)',
    })
    gsap.set(imgBox2, {
      clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)',
    })
    gsap.set(imgBox3, {
      clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)',
    })
    gsap.set(imgBox4, {
      clipPath: 'polygon(0 0, 0% 0, 0% 100%, 0% 100%)',
    })

    // サブコピーセット
    gsap.set(subBox, {
      opacity: 0,
      filter: "blur(10px)",
    })



    if (sW > 750) {

      gsap.to(copy1Paths, {
        opacity: 1,
        filter: "blur(0px)",
        duration: 3,
        ease: "power3.inOut",
        stagger: {
          each: .2,
          from: 'start'
        }
      })

      setTimeout(() => {
        gsap.to(imgBox1, {
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          duration: 2,
          ease: "power3.inOut",
        })
      }, 2000);

      setTimeout(() => {
        gsap.to(imgBox2, {
          clipPath: 'polygon(0 0%, 100% 0%, 100% 100%, 0% 100%)',
          duration: 8,
          ease: "power4.out",
        })
      }, 4000);

      setTimeout(() => {
        gsap.to(copy1Paths, {
          opacity: 0,
          filter: "blur(10px)",
          duration: 3,
          ease: "power3.inOut",
        })
      }, 5000);

      setTimeout(() => {
        gsap.to(copy2Paths, {
          opacity: 1,
          filter: "blur(0px)",
          duration: 3,
          ease: "power3.inOut",
          stagger: {
            each: .2,
            from: 'start'
          }
        })
      }, 7000);

      setTimeout(() => {
        gsap.to(imgBox3, {
          clipPath: 'polygon(0 0%, 100% 0%, 100% 100%, 0% 100%)',
          duration: 4,
          ease: "power3.inOut",
        })
      }, 8000);

      setTimeout(() => {
        gsap.to(copy2Paths, {
          opacity: 0,
          filter: "blur(10px)",
          duration: 3,
          ease: "power3.inOut",
        })
      }, 11000);

      setTimeout(() => {
        gsap.to(imgBox4, {
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          duration: 3,
          ease: "power3.inOut",
        })
      }, 13000);

      setTimeout(() => {
        gsap.to(copy3Paths, {
          opacity: 1,
          filter: "blur(0px)",
          duration: 3,
          ease: "power3.inOut",
          stagger: {
            each: .2,
            from: 'start'
          }
        })
      }, 15000);

      setTimeout(() => {
        gsap.to(copy4Paths, {
          opacity: 1,
          filter: "blur(0px)",
          duration: 3,
          ease: "power3.inOut",
        })
      }, 17000);

      setTimeout(() => {
        gsap.to(subBox, {
          opacity: 1,
          filter: "blur(0px)",
          duration: 3,
          ease: "power3.inOut",
        })
      }, 18000);

    } else {

      gsap.to(imgBox1, {
        clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
        duration: 2,
        ease: "power3.inOut",
      })

      setTimeout(() => {
        gsap.to(copy1Paths, {
          opacity: 1,
          filter: "blur(0px)",
          duration: 3,
          ease: "power3.inOut",
          stagger: {
            each: .2,
            from: 'start'
          }
        })
      }, 1000);

      setTimeout(() => {
        gsap.to(imgBox2, {
          clipPath: 'polygon(0 0%, 100% 0%, 100% 100%, 0% 100%)',
          duration: 10,
          ease: "power4.out",
        })
      }, 4000);

      setTimeout(() => {
        gsap.to(copy1Paths, {
          opacity: 0,
          filter: "blur(10px)",
          duration: 3,
          ease: "power3.inOut",
        })
      }, 5000);

      setTimeout(() => {
        gsap.to(copy2Paths, {
          opacity: 1,
          filter: "blur(0px)",
          duration: 3,
          ease: "power3.inOut",
          stagger: {
            each: .2,
            from: 'start'
          }
        })
      }, 7000);

      setTimeout(() => {
        gsap.to(imgBox3, {
          clipPath: 'polygon(0 0%, 100% 0%, 100% 100%, 0% 100%)',
          duration: 4,
          ease: "power3.inOut",
        })
      }, 8000);

      setTimeout(() => {
        gsap.to(copy2Paths, {
          opacity: 0,
          filter: "blur(10px)",
          duration: 3,
          ease: "power3.inOut",
        })
      }, 11000);

      setTimeout(() => {
        gsap.to(imgBox4, {
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          duration: 3,
          ease: "power3.inOut",
        })
      }, 13000);

      setTimeout(() => {
        gsap.to(copy3Paths, {
          opacity: 1,
          filter: "blur(0px)",
          duration: 3,
          ease: "power3.inOut",
          stagger: {
            each: .2,
            from: 'start'
          }
        })
      }, 15000);

      setTimeout(() => {
        gsap.to(subBox, {
          opacity: 1,
          filter: "blur(0px)",
          duration: 3,
          ease: "power3.inOut",
        })
      }, 17000);

      setTimeout(() => {
        gsap.to(copy4Paths, {
          opacity: 1,
          filter: "blur(0px)",
          duration: 3,
          ease: "power3.inOut",
        })
      }, 18000);

    }



  }
};
export default topMain;